var _title, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFewCloudsNight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "weather-night-cloudy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,13.2a6,6,0,0,1,0-10.4,1,1,0,0,0,0-1.731,8,8,0,0,0-11.8,5.123.25.25,0,0,0,.049.212.246.246,0,0,0,.2.094H12a8.557,8.557,0,0,1,1.423.119.248.248,0,0,0,.283-.181,6,6,0,0,1,6.841-4.346.249.249,0,0,1,.138.417A8.028,8.028,0,0,0,18.5,8a7.927,7.927,0,0,0,.19,1.724.245.245,0,0,0,.046.1,8.471,8.471,0,0,1,1.513,3.127.26.26,0,0,0,.048.1q.186.23.389.445a.25.25,0,0,1-.138.417.125.125,0,0,0-.1.136c.006.049.011.1.016.148a.244.244,0,0,0,.074.155,6.554,6.554,0,0,1,.975,1.211.25.25,0,0,0,.283.107,7.98,7.98,0,0,0,1.707-.736,1,1,0,0,0,0-1.731Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.094,15.074a.252.252,0,0,1-.1-.193A7,7,0,0,0,5.338,12.84a.249.249,0,0,1-.22.173A5.5,5.5,0,0,0,5.5,24H16a5,5,0,0,0,3.094-8.926ZM19,19a3,3,0,0,1-3,3H5.5a3.5,3.5,0,1,1,.448-6.971A1,1,0,0,0,7.064,14.2,5,5,0,0,1,17,15c0,.146-.007.289-.02.433a1,1,0,0,0,.5.959A3.007,3.007,0,0,1,19,19Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFewCloudsNight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/few_clouds_night.9f0b1f6c.svg";
export { ForwardRef as ReactComponent };